<template>
    <div class="mx-2">
        <div
        class="w-full md:w-[40rem] lg:w-[60rem] rounded-xl md:rounded-[3rem] overflow-hidden shadow-lg bg-white"
        >
            <div class="px-3 md:px-6 py-14 flex flex-col justify-center items-center">
                <div class="w-full md:w-8/12">
                    <div
                        class="text-center text-primary font-bold text-2xl lg:text-3xl mb-10"
                    >
                        Track your Package
                    </div>

                    <div class="flex w-full">
                        <label for="location-search" class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Input ID Tracking</label>
                        <div class="relative w-full">
                            <input type="search" v-model="trackingId" id="location-search" name="tracking_id" class="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50  md:rounded-lg border border-[#143212] focus:outline-none" placeholder="Input ID Tracking" required>
                            <button type="button" :disabled="!trackingId" @click="track" class="absolute top-0 right-0 p-2.5 text-sm font-medium text-white bg-primary hover:bg-[#1d4b1a] md:rounded-lg border border-[#143212] focus:ring-4 focus:outline-none">
                                <img class="w-8 h-5" src="/img/icons/icon_srch.svg" alt="">
                                <span class="sr-only">Search</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-show="isErrorSubmit" class="mt-5">
                    {{ errorMessage }}
                </div>
                <!-- Loading Animation -->
                <div v-show="animLoad" class="loadingio-spinner-spinner-hteea2kk7a">
                    <div class="ldio-hwslmtvkfpi">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <!-- Loading Animation end -->
                <div class="mt-5 w-full md:w-8/12" v-if="dataShipment">
                    <template v-if="dataShipment?.id !== undefined">
                        <template v-if="dataShipment.status == 'send' || dataShipment.status == 'delivered'" >
                            <div class="md:flex flex-col flex-wrap hidden">
                                <div class="overflow-x-auto mx-0 lg:-mx-8">
                                    <div class="inline-block min-w-full py-2 lg:px-8">
                                        <div class="overflow-hidden border border-primary rounded-lg bg-[#e9e9e9]">
                                            <table
                                            class="min-w-full text-center text-sm font-light ">
                                                <tbody class="text-left text-primary">
                                                    <tr>
                                                        <td rowspan="2"
                                                            class="whitespace-nowrap border-r border-primary px-6 py-2 font-medium">
                                                            <div class="font-bold">
                                                                Truck Number:
                                                            </div>
                                                            <div>
                                                                {{ dataShipment.driver_plate }}
                                                            </div>
                                                        </td>
                                                        <td
                                                            class="whitespace-nowrap border-r border-b border-primary px-6 py-2 ">
                                                            <span class="font-bold">Driver:</span> {{ dataShipment.driver_name }}
                                                        </td>
                                                        <td
                                                            class="whitespace-nowrap px-6 py-2 border-b border-primary">
                                                            <span class="font-bold">PO Number:</span> {{ dataShipment.po_number }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            class="whitespace-nowrap border-r px-6 py-2 border-primary">
                                                            <span class="font-bold">Phone:</span> {{ dataShipment.driver_phone }}
                                                        </td>
                                                        <td
                                                            class="whitespace-nowrap px-6 py-2 ">
                                                            <span class="font-bold">Waybill Number (SJ):</span> {{ dataShipment.waybill_number }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="rounded-lg bg-[#e9e9e9] text-primary px-8 py-3 mb-3 md:hidden">
                                <div>
                                    <div class="font-bold">Truck Number:</div>
                                    <div class="ml-2">{{ dataShipment.driver_plate }}</div>
                                </div>
                                <div>
                                    <div class="font-bold">Driver:</div>
                                    <div class="ml-2">{{ dataShipment.driver_name }}</div>
                                </div>
                                <div>
                                    <div class="font-bold text-primary">Phone:</div>
                                    <div class="ml-2">{{ dataShipment.driver_phone }}</div>
                                </div>
                                <div>
                                    <div class="font-bold text-primary">PO Number:</div>
                                    <div class="ml-2">{{ dataShipment.po_number }}</div>
                                </div>
                                <div>
                                    <div class="font-bold">Waybill Number (SJ):</div>
                                    <div class="ml-2">{{ dataShipment.waybill_number }}</div>
                                </div>
                            </div>
                        </template>

                        <div class="flex flex-col gap-2">
                            <template v-if="dataShipment.status == 'send' || dataShipment.status == 'delivered'">
                                <div class="rounded-lg bg-[#e9e9e9] text-primary px-8 py-3">
                                    <div class="grid grid-cols-12">
                                        <div class="col-span-11 md:col-span-4"><span class="font-bold">SENT</span> <br> ({{ dataShipment.date_send }})</div>
                                        <div class="col-span-1 mx-auto hidden md:block h-full w-[1px] bg-black"></div>
                                        <div class="col-span-12 md:col-span-7 my-auto max-sm:pt-4">Barang sudah dimuat, truk dalam perjalanan </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="dataShipment.status == 'delivered'" >
                                <div class="rounded-lg bg-[#e9e9e9] text-primary px-8 py-3">
                                    <div class="grid md:grid-cols-12 grid-rows-1">
                                        <div class="col-span-11 md:col-span-4"><span class="font-bold">DELIVERED</span> <br> ({{ dataShipment.date_delivered }})</div>
                                        <div class="col-span-1 mx-auto hidden md:block h-full w-[1px] bg-primary"></div>
                                        <div class="col-span-12 md:col-span-7 my-auto max-sm:pt-4">
                                            Barang sudah sampai <br>
                                            <template v-if="dataShipment.attachments?.length">
                                                <span v-for="(attach, index) in dataShipment.attachments" :key="index">
                                                    <a class="text-blue-400 italic" target="_blank" :href="attach">[Lampiran {{ index + 1 }}]</a>
                                                </span>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="dataShipment.note?.length">
                                <div class="rounded-lg bg-[#e9e9e9] text-primary px-8 py-3">
                                    <div class="font-bold">
                                        Note:
                                    </div>
                                    <div class="italic">
                                        {{ dataShipment.note }}
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['csrf_token', 'tracking_id', 'not_found', 'errorMessage'],
    data: function () {
        return {
            dataShipment: null,
            trackingId: "",
            isErrorSubmit: false,
            animLoad: false
        };
    },
    mounted() {
        this.dataShipment = this.tracking_id;
        this.isErrorSubmit = this.not_found;
        const url = new URL(window.location.href);
        this.trackingId = url.searchParams.get('tracking_id');
    },
    methods: {
        track: function () {
            let _this = this
            _this.isErrorSubmit = false;
            _this.animLoad = true;
            _this.dataShipment = null;

            axios.post('/track', {
                tracking_id: _this.trackingId
            })
            .then(function (response) {
                _this.isErrorSubmit = false;
                _this.animLoad = false;
                _this.dataShipment = response.data;
            })
            .catch(function (error) {
                _this.isErrorSubmit = true;
                _this.animLoad = false;
                _this.dataShipment = null;
                console.log(error);
            });

            const url = new URL(window.location.href);
            url.searchParams.set('tracking_id', _this.trackingId);
            window.history.pushState({ path: url.href }, '', url.href);
        },
    },
};
</script>
